{
	"async_pickers": {
		"selected_count_one": "1 selected",
		"selected_count_other": "{{count}} selected"
	},
	"data_table": {
		"column_menu": {
			"autosize_column": "Autosize this column",
			"clear_sort": "Clear sort",
			"hide_column": "Hide column",
			"no_pin": "No pin",
			"pin_column": "Pin column",
			"pin_left": "Pin left",
			"pin_right": "Pin right",
			"sort_asc": "Sort ascending",
			"sort_desc": "Sort descending",
			"trigger": "Column options for {{column}}"
		},
		"column_settings": {
			"drag_handle": "Reorder column",
			"no_results": "No columns match",
			"pin_column": "Pin {{column}}",
			"pin_left": "Pin left",
			"pin_right": "Pin right",
			"reset": "Reset",
			"search_placeholder": "Search columns...",
			"show_all": "Show all",
			"toggle_visibility": "Toggle {{column}}",
			"trigger": "Columns",
			"unpin": "Unpin"
		},
		"error": "Failed to load data",
		"loading_more": "Loading more...",
		"no_results": "No results",
		"pagination": {
			"go_to_page": "Go to page {{page}}",
			"more_pages": "More pages",
			"next": "Next",
			"previous": "Previous",
			"rows_per_page": "Rows per page"
		},
		"select_all": "Select all rows",
		"select_row": "Select row",
		"sort_by": "Sort by {{column}}"
	},
	"http_errors": {
		"admin_forbidden": "You don't have permission to perform this admin action.",
		"anonymous_sign_in_disabled": "Anonymous sign-in is disabled.",
		"anonymous_user_cannot_change_password": "Anonymous users cannot change their password.",
		"anonymous_users_cannot_sign_in_again_anonymously": "Anonymous users can't sign in anonymously again.",
		"auth_credentials_missing": "Sign in before continuing.",
		"auth_csrf_invalid": "Your session security token is invalid. Refresh and try again.",
		"auth_email_not_found": "No account with this email address could be found.",
		"auth_jwt_invalid": "Your sign-in session is invalid or has expired. Sign in again.",
		"auth_session_issue_failed": "We couldn't complete sign-in. Please try again.",
		"auth_token_invalid": "Your sign-in session is invalid or has expired. Start again.",
		"backoffice_admin_deleted": "This admin account has been deleted.",
		"backoffice_admin_not_found": "This admin account could not be found.",
		"backoffice_auth_credentials_missing": "Sign in as an admin before continuing.",
		"backoffice_change_password_otp_invalid": "The email code is invalid. Please try again.",
		"backoffice_change_password_otp_unavailable": "Email codes are not available for changing this admin password.",
		"backoffice_csrf_invalid": "Your admin session security token is invalid. Refresh and try again.",
		"backoffice_email_already_in_use": "An admin account with this email already exists.",
		"backoffice_email_otp_token_invalid": "Your verification session has expired. Request a new code.",
		"backoffice_invalid_email_or_password": "The email or password is invalid.",
		"backoffice_invalid_password": "The password is invalid.",
		"backoffice_invite_invalid": "This admin invitation is invalid or has expired.",
		"backoffice_jwt_invalid": "Your admin session is invalid or has expired. Sign in again.",
		"backoffice_no_change_password_method_available": "No available method can change this admin password.",
		"backoffice_rate_limited_one": "Too many attempts: try again in {{count}} minute.",
		"backoffice_rate_limited_other": "Too many attempts: try again in {{count}} minutes.",
		"backoffice_reset_password_session_missing": "The admin password reset session is missing.",
		"backoffice_reset_password_token_invalid": "The admin password reset token is invalid or expired.",
		"backoffice_self_edit_forbidden": "You cannot edit your own admin account here.",
		"backoffice_session_expired": "Your admin session has expired. Sign in again.",
		"backoffice_session_invalid": "Your admin session is no longer valid. Sign in again.",
		"backoffice_session_issue_failed": "We couldn't complete sign-in. Please try again.",
		"change_password_otp_invalid": "The email code is invalid. Please try again.",
		"change_password_otp_unavailable": "Email codes are not available for changing this password.",
		"default": "Oops! Something went wrong.",
		"email_already_in_use": "An account with this email already exists.",
		"email_otp_token_invalid": "Your verification session has expired. Request a new code.",
		"impersonation_token_invalid": "This impersonation link is invalid or has already expired.",
		"invalid_code": "The code is invalid.",
		"invalid_delete_account_otp": "The account deletion code is invalid.",
		"invalid_email_or_password": "The email or password is invalid.",
		"invalid_password": "The password is invalid.",
		"maintenance_mode": "The service is temporarily in maintenance mode.",
		"no_change_password_method_available": "No available method can change this password.",
		"otp_issuance_throttled": "Too many code requests. Please wait before requesting a new one.",
		"password_too_long": "The password is too long.",
		"password_too_short": "The password is too short.",
		"permission_denied": "Your account is signed in, but it doesn't have the permissions required to view this page.",
		"reset_password_session_missing": "The password reset session is missing.",
		"reset_password_token_invalid": "The password reset token is invalid or expired.",
		"session_expired": "Your session has expired. Sign in again.",
		"session_invalid": "Your session is no longer valid. Sign in again.",
		"session_not_found": "This session could not be found.",
		"unauthorized": "You're not signed in. Please log in to continue.",
		"user_banned": "This user account has been banned.",
		"user_deleted": "This user account has been deleted.",
		"user_not_found": "This user could not be found.",
		"validation_error": "Some of the information you entered is invalid."
	},
	"inline_filters": {
		"clear": "Clear filter",
		"clear_all": "Clear all"
	},
	"input_password": {
		"hide": "Hide password",
		"show": "Show password"
	},
	"list_input_search": {
		"label": "Search",
		"clear": "Clear search"
	},
	"query_breadcrumbs": {
		"error": "Error",
		"no_data": "Detail"
	},
	"sidebar": {
		"close": "Close menu",
		"open": "Open menu"
	}
}
